/*
 * Jira Ticket:
 * Created Date: Thu, 26th Mar 2020, 11:33:24 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Layout } from 'react-admin';
import CustomMenu from './Menu';
import CustomAppBar from './CustomAppBar';
import AccessDenied from './Error/AccessDenied';
import NotFound from './Error/NotFound';
import EmptyResource from './Error/EmptyResource';

const CustomLayout = ({ modifiedSinceLastSubmit, ...props }) => (
  <Layout {...props} menu={CustomMenu} appBar={CustomAppBar} />
);

export default CustomLayout;

export { AccessDenied, NotFound, EmptyResource };
